export default __webpack_public_path__ + "static/media/service_1.329fd998.png";